import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // These datasets are low-churn and every mutation invalidates its own
      // queries, so a long staleTime is safe and cuts refetch egress: a
      // screen refocus inside this window serves cache instead of hitting
      // the API.
      staleTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
      networkMode: "online",
    },
    mutations: {
      retry: 0,
      networkMode: "online",
    },
  },
});

export function starterQueryKey(userId: string) {
  return ["starter", userId] as const;
}

export function starterLogsQueryKey(starterId: string) {
  return ["starter-logs", starterId] as const;
}

export function recipeProgressQueryKey(userId: string, recipeId: string) {
  return ["recipe-progress", userId, recipeId] as const;
}

export function recipeTimersQueryKey(userId: string, recipeId: string) {
  return ["recipe-timers", userId, recipeId] as const;
}
